import(/* webpackMode: "eager", webpackExports: ["Blog"] */ "/app/src/screens/Blog/ui/Blog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Product"] */ "/app/src/screens/Product/ui/Product.tsx");
